import { useRef, useState } from "react";
import { Button } from "../ui/button";
import { fileUrl } from "../../lib/api";

const fmt = (s) => `${String(Math.floor(s / 60)).padStart(2, "0")}:${(s % 60).toFixed(1).padStart(4, "0")}`;

// Play the song and tap once at the start of each line to record its timing
export const TimingRecorder = ({ song, lyrics, onDone }) => {
  const audio = useRef(null);
  const [rec, setRec] = useState(null);
  const lines = (lyrics || "").split("\n").map((l) => l.trim()).filter(Boolean);
  if (!song?.id || !song.audio_path) return <p className="text-xs opacity-70">Enregistrez d'abord la comptine avec sa musique pour minuter au tap.</p>;

  const start = () => { audio.current.currentTime = 0; audio.current.play(); setRec([]); };
  const tap = () => {
    const next = [...rec, audio.current.currentTime];
    if (next.length < lines.length) return setRec(next);
    audio.current.pause();
    setRec(null);
    onDone(["# Minutage enregistré au tap : minutes:secondes.dixièmes puis le vers", "", ...lines.map((l, i) => `${fmt(next[i])} ${l}`)].join("\n"));
  };

  return (
    <div className="rounded-2xl bg-[#FFF9F2] p-3 space-y-2" data-testid="timing-recorder">
      <audio ref={audio} src={fileUrl(`/files/songs/${song.id}/audio`)} preload="auto" controls className="w-full" />
      {rec === null ? (
        <Button type="button" variant="outline" className="rounded-full" onClick={start} data-testid="timing-recorder-start">Enregistrer au tap</Button>
      ) : (
        <div className="space-y-2">
          <p className="text-sm">Touchez au début de chaque vers. Prochain vers : <strong>{lines[rec.length]}</strong> ({rec.length + 1}/{lines.length})</p>
          <Button type="button" className="w-full rounded-full bg-[#FF8A1F] hover:bg-[#f07a10] h-14 text-lg" onClick={tap} data-testid="timing-recorder-tap">Vers suivant</Button>
        </div>
      )}
    </div>
  );
};
